// extracted by mini-css-extract-plugin
var _1 = "NUsKT";
export { _1 as "base" }
